module.exports = __webpack_public_path__ + "static/media/PREMIUM-FEATURES.8a501067.png";